import { List } from "@mui/material";
import { VideoThemeWrapper } from "./VideoThemeWrapper";
import { getComponentKey } from "../../utils/utils";

export default function VideoList({ listData }) {
  return (
    <List>
      {listData.map((theme) => {
        const key = getComponentKey();
        return <VideoThemeWrapper {...theme} key={key} />;
      })}
    </List>
  );
}
